import { createSlice } from "@reduxjs/toolkit";

export const ServiceIdSlice = createSlice({
  name: "Product-Id",
  initialState: {
    serviceId: "",
  },
  reducers: {
    setServiceId: (state, action) => {
      state.serviceId = action.payload;
    },
  },
});

export const { setServiceId } = ServiceIdSlice.actions;

export default ServiceIdSlice.reducer;
